import ProgressBar from "components/ProgressBar";
import React from "react";

export default function Header({ currentStep, setCurrentStep }) {
   return <ProgressBar stepLength={10} currentStep={currentStep} setCurrentStep={setCurrentStep} />;
}
